export default __webpack_public_path__ + "static/media/mediumroast.6e30b101.jpg";